import { Component, EventEmitter, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { HistoryInventory } from 'src/app/models/inventory/history-inventory';
import { HistoricalIncomeDispatch } from 'src/app/models/rental/historical-income-dispatch';
import { EndpointDictionary } from 'src/app/utils/endpoints-dictionary';
import { FunctionsService, HeaderFilters, HttpService, MenuBreadCrumb, MessageService, params, TableColumns, TableConfiguration } from 'brainloper-ui';
import { combineLatest, Subject, takeUntil } from 'rxjs';
import { GenericResponse } from 'src/app/models/commos/generic-response';
import { EquipmentRental } from 'src/app/models/rental/equipment-rental';
import { MatTabChangeEvent } from '@angular/material/tabs';


enum stateTab  {
  NEWREGISTER = 1,
  EDITREGISTER = 2,
  VIEWDETAIL = 3,
  TABLE = 4
}

@Component({
    selector: 'app-rental-income-dispatch',
    templateUrl: './rental-income-dispatch.component.html',
    styleUrls: ['./rental-income-dispatch.component.scss'],
    standalone: false
})

export class RentalIncomeDispatchComponent implements OnInit, OnDestroy {

  public EndpointDictionary = EndpointDictionary
  public stateTab = stateTab;
  public currentState: stateTab = stateTab.TABLE;
  public title = "";
  public labelTabRegister = ""
  public rentalOrderState: number = null;
  public labels = [];
  public selected = new FormControl(0);
  public paramsRentalOrder: params[] = [];
  public rentalOrderId: number = null;

  public isIncome: boolean = true;
  private unsubscribe$ = new Subject<void>();
  public dataDetails: Array<EquipmentRental> = [];

  public paramsIncomeDispatch: params[] = []
  public reloadTablaIncomeDispatch = new EventEmitter<any>();
  public configurationIncomeDispatch: TableConfiguration = {
    edit: false,
    add: true,
    delete: false,
    selectable: false,
    addPer: true,
    editPer: true,
    primaryKey: 'id',
    print: false,
    exportXslx: true,
    hideTitle: true,
    view: true,
  };

  public columnsIncomeDispatch: TableColumns<HistoricalIncomeDispatch>[] = [
    {
      ID: 'consecutive',
      label: '#',
      type: 'text',
      style: {
        textAlign: 'center',
        width: '80px',
        movil: 'no-movil',
      },
    },
    {
      ID: 'date',
      label: 'Fecha',
      type: 'dateWithTime',
      style: {
        textAlign: 'center',
      },
    },
    {
      ID: 'userName',
      label: 'Responsable',
      type: 'text',
      style: {
        textAlign: 'center',
        movil: 'no-movil',
      },
    },
    {
      ID: 'clientName',
      label: 'Cliente',
      type: 'text',
      style: {
        textAlign: 'center',
      },
    },
    {
      ID: 'itemsCount',
      label: 'Número de Items',
      type: 'text',
      style: {
        textAlign: 'center',
        movil: 'no-movil',
      },
    },
    {
      ID: 'rentalOrderId',
      label: '# Orden Alquiler',
      type: 'number',
      style: {
        textAlign: 'center',
        movil: 'no-movil',
      },
    },
  ];


  // tabla detalle
  public reloadTablaDetails = new EventEmitter<any>();
  public configurationDetails: TableConfiguration = {
    hideTitle: true,
    primaryKey: 'id',
  };
  public columnsDetails: TableColumns<EquipmentRental>[] = [
    {
      ID: 'equipmentCode',
      label: 'Código Equipo',
      type: 'text',
      style: {
        textAlign: 'center',
        movil: 'no-movil',
      },
    },
    {
      ID: 'equipmentName',
      label: 'Nombre',
      type: 'text',
      style: {
        textAlign: 'center',
      },
    },
    {
      ID: 'rentalCost',
      label: 'Costo Alquiler',
      type: 'thousandSeparator',
      style: {
        textAlign: 'center',
      },
    }
  ];

  headerFilters: Array<HeaderFilters> = [];

  headerFileXlsm: Array<params> = [
    { id: 'consecutive', value: 'Consecutivo' },
    { id: 'date', value: 'Fecha de Registro' },
    { id: 'userName', value: 'Responsable' },
    { id: 'userId', value: 'Cédula' },
    { id: 'providerName', value: 'Proveedor' },
    { id: 'totalCost', value: 'Costo Total' },
    { id: 'itemsCount', value: 'Número de Items' },
    { id: 'orderNumber', value: '# Orden alquiler' },
  ];

  public menuBreadCrumb: Array<MenuBreadCrumb> = [
    {
      name: "Inicio",
      router: '/inicio',
    },
    {
      name: this.title,
      current: true
    },
  ]

  constructor(
    private activeRoute: ActivatedRoute,
    private router: Router,
    private http: HttpService,
    private message: MessageService,
    private functionEter: FunctionsService,
  ) {
    combineLatest([
      this.activeRoute.queryParamMap,
      this.activeRoute.data
    ])
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe(([params, data]) => {

      const orderIdParam = params.get('orderId');
      this.rentalOrderId = orderIdParam && !isNaN(parseInt(orderIdParam)) ? parseInt(orderIdParam) : null;
      if(this.rentalOrderId) this.addIncomeDispatch()

      this.isIncome = data['isIncome'];
      this.paramsIncomeDispatch = [
        {
          id: 'isIncome',
          value: this.isIncome,
        },
      ];
      if (this.isIncome == false) {
        this.title = 'Histórico de Despachos';
        this.labelTabRegister = 'Nuevo Despacho';
        this.rentalOrderState = 1;
      } else {
        this.title = 'Histórico de Ingresos';
        this.labelTabRegister = 'Nuevo Ingreso';
        this.rentalOrderState = 4;
      }

      this.menuBreadCrumb[1].name = this.title;

      this.paramsRentalOrder = [{ id: 'stateId', value: this.rentalOrderState }];
    });
  }


   ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  addIncomeDispatch($event?: any) {
    this.selected.setValue(1);
    this.currentState = stateTab.NEWREGISTER
  }

  goBackButtonHandlerItems($event: boolean){
    this.selected.setValue(0);
    this.rentalOrderId = null;
  }

  async editIncomeDispatch($event: any) {
  }

  async viewDetailIncomeDispatch($event: HistoricalIncomeDispatch[]) {
    this.selected.setValue(1);
    this.currentState = stateTab.VIEWDETAIL
    this.dataDetails = $event[0].equipments;
      this.labelsFunction($event[0]);


  }

  async saveInputInventoryEquipment($event: HistoryInventory){
    this.message.openLoading("Cargando",  `Guardando ${this.isIncome? 'Ingreso': 'Despacho'}`);
    var incomeDispath:HistoricalIncomeDispatch = {
      userId: $event.userId,
      clientId: $event.providerId,
      rentalOrderId: $event.rentalorderId,
      isIncome: this.isIncome,
      comment: $event.comment,
      equipments: $event.items.map((item) => {
        return {
          equipmentId: item.itemInventoryId
        }
      }),
    };
    var res = await this.http.postDataBody<GenericResponse>(EndpointDictionary.HistoricalIncomeDispatch.CRUD_HISTORICAL_INCOME_DISPATCH, incomeDispath)
    if(res){
      this.message.SuccessToast(`${this.isIncome? 'Ingreso': 'Despacho'} guardado correctamente`);
      this.reloadTablaIncomeDispatch.emit();
      this.selected.setValue(0);
    }
    this.message.closeLoading();

  }

  selectedTabChange($event: MatTabChangeEvent){
    if($event.index == 0){
      this.rentalOrderId = null;
      this.currentState = stateTab.TABLE;
    }

    this.selected.setValue($event.index)
  }

  private labelsFunction(data: HistoricalIncomeDispatch) {
    this.labels = [
      {
        label: 'Consecutivo (#):',
        value: data.consecutive,
        edit: false,
      },
      {
        label: '# Orden:',
        value: data.rentalOrderNumber,
        edit: false,
      },
      {
        label: 'Responsable:',
        value: data.userName,
        edit: false,
      },
      {
        label: 'Fecha:',
        value: this.functionEter.dateDB(new Date(data.date)),
        edit: false,
      },
      {
        label: 'Cliente:',
        value: data.clientName,
        edit: false,
      },
    ];
  }

}
